import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addJumpLine',
  standalone: true
})
export class AddJumpLinePipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.replace(/\n/g, '<br>') : value;
  }

}
